import Column from 'bloko/blocks/column';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import WorkInProfession from 'src/components/WorkInProfession';
import WorkInProfessionMobile from 'src/components/WorkInProfession/Mobile';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { SearchCatalogListMain } from 'src/models/searchCatalogList';
import LetterLinks from 'src/pages/SearchCatalogList/components/LetterLinks';

const TrlKeys = {
    specializations: 'exp.search.catalog.list.main.specializations',
};

const ContentMain: TranslatedComponent<SearchCatalogListMain> = ({ catalogType, letters, trls }) => {
    const specializations = useSelector((state) => state.professionalRoleCategoryCollection);

    return (
        <>
            <LetterLinks catalogType={catalogType} letters={letters} />
            {specializations && (
                <>
                    <VSpacing base={10} xs={8} />
                    <Column xs="4" s="0" m="0" l="0" container>
                        <WorkInProfessionMobile customTitle={trls[TrlKeys.specializations]} disableTitleLink />
                    </Column>
                    <Column xs="0" s="8" m="12" l="16" container>
                        <WorkInProfession customTitle={trls[TrlKeys.specializations]} disableTitleLink />
                    </Column>
                    <VSpacing base={12} xs={10} />
                </>
            )}
        </>
    );
};

export default translation(ContentMain);
